import { Injectable } from '@angular/core';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';
import { Observable } from 'rxjs';

const URL = SERVICES.LOGIN.PATH;
@Injectable()
export class UserService extends AbstractService<any> {
  constructor(
    http: HttpClient,
    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  public userPasswordChange(data: any): Observable<any> {
    const url = SERVICES.USER_PASSWORD.PATH;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data,
    });
  }
}
